import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "button"
  // NOTE: a debug override to load this controller even in non-native env
  // static get shouldLoad() { return true }

  // Tag helper params:
  // data: {
  //   controller: "bridge--button",
  //   bridge_title: Current.user ? "Settings" : "Sign in",
  //   bridge_icon: 'account_circle'
  // }

  // HTML:
  // <a data-controller="bridge--button"
  //   data-bridge-title="Settings"
  //   data-bridge-icon="account_circle"
  //   href="/settings/edit">
  // Settings</a>

  // To hide the button:
  // - send 'disconnect' or do not send 'connect'
  // - pass empty title and icon

  connect() {
    super.connect()
    const element = this.bridgeElement
    const title = element.bridgeAttribute("title")
    const icon = element.bridgeAttribute("icon")
    this.send("connect", {title, icon}, () => {
      this.element.click()
    })
  }
}
